import { useEffect, useState } from 'react';

import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useConfig, useNotification, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { useEventBus } from '../../../../hooks/use-event-bus';
import FormsService from '../../../../services/forms-service/forms-service';
import { EventFormsDialog } from '../../../../types/event-bus';
import { Dialog } from './styles';

export default function ModalUnassignForm() {
    const [open, setOpen] = useState(false);
    const [formId, setFormId] = useState<string | null>(null);
    const [formName, setFormName] = useState<string | null>(null);

    const { listen, publish } = useEventBus();
    const { showSuccess, showError } = useNotification();

    const { config } = useConfig();
    const oidc = useOidcWithAdmin();

    useEffect(() => {
        return listen('formsDialog', (event: any) => {
            const data = event.data as EventFormsDialog['data'];

            if (data.type === 'unassign') {
                setOpen(true);
                setFormName(data.formName);
                setFormId(data.formId);
            }
        });
    }, [listen]);

    const handleClose = () => {
        setOpen(false);
    };

    const submit = async () => {
        const formsService = FormsService.getInstance(config, oidc.oidcService);
        setOpen(false);
        try {
            await formsService.unassignForm(formId as string);
            publish({ messageType: 'forms', data: { type: 'reload' } });
            showSuccess('The forms have been unassigned');
        } catch (error) {
            showError('Failed to unassign form');
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Unassign Form</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure you want to unassign "{formName}" from this patient?</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant='contained' color='error' onClick={submit}>
                    Unassign
                </Button>
            </DialogActions>
        </Dialog>
    );
}
